var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3C7 2.44772 7.44772 2 8 2C8.55228 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4H18C19.6569 4 21 5.34314 21 7V9V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V9V7C3 5.34315 4.34315 4 6 4H7V3ZM8 6H16H18C18.5523 6 19 6.44772 19 7V8H5V7C5 6.44772 5.44772 6 6 6H8ZM5 10V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V10H5ZM13.449 12C13.449 11.5635 13.1659 11.1774 12.7495 11.0462C12.3332 10.915 11.8799 11.069 11.6296 11.4267L9.18066 14.9267C8.96691 15.2322 8.94085 15.6312 9.11307 15.9619C9.28528 16.2926 9.62716 16.5 10 16.5H10.5646V18C10.5646 18.437 10.8484 18.8234 11.2653 18.9542C11.6823 19.0849 12.1359 18.9299 12.3855 18.5712L14.8208 15.0712C15.0335 14.7655 15.0588 14.367 14.8863 14.0369C14.7139 13.7069 14.3724 13.5 14 13.5H13.449V12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBolt);
export default __webpack_public_path__ + "static/media/calendar_bolt.ea484de3f90b646696aac66bc280e38d.svg";
export { ForwardRef as ReactComponent };